import { Box, useTheme } from '@mui/material';
import { DateTimeValidationError, PickerChangeHandlerContext } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Moment } from 'moment';
import { useEffect, useState } from 'react';

import { FlexRow } from '../../../styled/Flex';
import FormDataErrorField from '../FormDataErrorField';
import { CustomDateProps, getValue } from './CustomDateTimePicker';

const CustomDatePicker = (props: CustomDateProps) => {
  const theme = useTheme();

  const [errorMessage, setErrorMessage] = useState<string>();
  const [showError, setShowError] = useState<boolean>(false);

  useEffect(() => {
    const [elementId] = props.names[0].split('.');
    props.setDisableSubmit?.({ [elementId]: errorMessage ? true : false });
  }, [errorMessage, props, showError]);

  return (
    <Box>
      <FlexRow columnGap={2}>
        {props.names.map((name, index) => (
          <Box key={name}>
            <DatePicker
              desktopModeMediaQuery={theme.breakpoints.up('md')}
              value={getValue(props.elementValue, name, props.type)}
              onChange={(date: Moment | null, context: PickerChangeHandlerContext<DateTimeValidationError>) => {
                if (context.validationError == null) {
                  props.onChange(date, name);
                } else {
                  props.onChange(null, name);
                }
              }}
              onError={(error: DateTimeValidationError) => {
                if (error) {
                  setErrorMessage('Invalid date');
                } else {
                  setErrorMessage(undefined);
                }
              }}
              format={props.format}
              // minDate={getMinDate(props.elementValue, props.names[0], props.type, props.range, index)} // TODO plugin not support min/max date for undefined value
              // maxDate={getMaxDate(props.elementValue, props.names[1], props.type, props.range, index)}
              disabled={props.disabled}
              timezone={props.timezone}
              slotProps={{
                field: { clearable: true },
                textField: {
                  id: name,
                  name,
                  placeholder: props.placeholder,
                  onBlur: () => {
                    setShowError(true);
                  },
                },
              }}
            />
          </Box>
        ))}
      </FlexRow>
      <FormDataErrorField
        error={props.error?.length ? props.error : showError && errorMessage ? errorMessage : undefined}
        touched={props.touched ?? undefined}
      />
    </Box>
  );
};

export default CustomDatePicker;
